import { render } from "./fold-panel.vue?vue&type=template&id=457c3ed3&scoped=true&ts=true"
import script from "./fold-panel.vue?vue&type=script&lang=ts"
export * from "./fold-panel.vue?vue&type=script&lang=ts"

import "./fold-panel.vue?vue&type=style&index=0&id=457c3ed3&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457c3ed3"]])

export default __exports__